import { EmptyMessageCardIcon } from '../../icon';

interface Props {
    label: string
}

const BlankConvCard = (props: Props) => {
    return (
        <div className='d-flex flex-direction my-auto'>
            <div className='mx-auto'>
                <EmptyMessageCardIcon />
            </div>
            <div className='color-conv-hist-date h6-regular mx-auto my-2'>
                {props.label}
            </div>
        </div>
    )
}

export default BlankConvCard